export const state = {
  pageTypes: [
    {id: 1, type: 'info_page', slug: 'info'},
    {id: 2, type: 'contact_page', slug: 'contact'},
    {id: 3, type: 'questionnaire_page', slug: 'questionnaire'},
    {id: 4, type: 'thanks_page', slug: 'thanks'},
    {id: 5, type: 'noise_test_page', slug: 'noise'},
    {id: 6, type: 'tonal_test_page', slug: 'tonal'},
    {id: 7, type: 'user_info_page', slug: 'user_info'},
    {id: 8, type: 'solsticio_page', slug: 'solsticio'},
    {id: 9, type: 'tonal_test_result_page', slug: 'tonal_test_result'},
    {id: 10, type: 'noise_test_result_page', slug: 'noise_test_result'},
    //{id: 11, type: 'biosignals_page', slug: 'biosignals'},
  ],
  formInputNames: [
    {id: 1, name:'name'},
    {id: 2, name:'email'},
    {id: 3, name:'phone'},
    {id: 4, name:'city'},
  ]
}
